import { Button, Dialog, DialogBody, DialogFooter } from "@material-tailwind/react";

export function SavedModal({ size, handleOpen, showtext }) {
    return (
        <>
            <Dialog open={size} handler={handleOpen} size="sm" className="rounded-none">
                <DialogBody className="text-center text-base font-semibold">
                    {showtext} Folder is empty
                </DialogBody>
                <DialogFooter className="w-full flex justify-center">
                    <Button
                        variant="gradient"
                        onClick={() => handleOpen(null)}
                        className="px-3 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded-md text-gray-700 dark:text-gray-300"
                    >
                        <span>cancel</span>
                    </Button>
                </DialogFooter>
            </Dialog>
        </>
    );
}
